import React, { useState, memo, useCallback } from 'react';
import { Search } from '@mui/icons-material';
import {
  Modal as Model1, ThemeProvider, ModalWrapper, ModalFooter, Autocomplete, Checkbox
} from '@workboard/wobo-ui';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import GoalServices from '../../../services/goal.services';
import { reactLoader, removeReactLoader } from '../../../utils/common';
import { KeyDownEvent } from '../../../utils/eventKey';

const StyledModal = styled(Model1)`
	${ModalWrapper} { 
	  width: 700px;
	}
	${ModalFooter} { 
	  button {
		height: 40px;
	  }
	}`;

export const CopyKrModal = memo((props) => {
  const [goalListForSearch, setGoalListForSearch] = useState([]);
  const [okrData, setOkrData] = useState(null);
  const [options, setOptions] = useState({
    comments: false,
    move: false
  })
  const [message, setMessage] = useState('')
  const goalServices = new GoalServices();
  const { t } = useTranslation();

  const handleModalClose = useCallback(() => {
    if (props.handleClose) {
      props.handleClose();
    } else {
      window.closeKrCopyModal();
    }
  }, [props]);

  const goalSearch = async (term) => {
    if (term.length >= 1) {
      console.log('props', props.metric.nested_krs)
      const nestKr = props.metric && props.metric.nested_krs != undefined ? props.metric.nested_krs : '';
      const response = await goalServices.searchRollupOkrs({
        term,
        type: 'okr',
        copyKr: 1,
        goal_start: props.metric.startDateText || props.metric.start_date,
        goal_end: props.metric.endDateText || props.metric.end_date,
        nestedKr: nestKr.length
      })
      const searchresults = response.data.data.goals
      setGoalListForSearch(searchresults)
    }
  }

  const renderSearchObjective = ({ ...props }, context) => {
    let year = props.okrPeriod
    if (year.includes('Q')) {
      const yearArray = year.split(' ');
      year =			yearArray[0]
			+ t(' FY ') + yearArray[1].slice(-2)
    } else if (year.includes('FY')) {
      year = t(' FY ') + year.slice(-2)
    }
    return (
      <div
        onClick={() => selectOKr(props, context && context.closeBox ? context.closeBox : null)}
        onKeyDown={(e) => {
			  e.preventDefault();
			  if (e.key === 'Enter') {
			    selectOKr(props, context && context.closeBox ? context.closeBox : null)
			  }
        }}
        style={{
          display: 'flex', justifyContent: 'start', alignItems: 'start', padding: 2, paddingLeft: 8, marginTop: 5, cursor: 'pointer'
        }}
      >
        <div
          className="icon icon-outline-bar_chart-24px"
          style={{ marginRight: 8 }}
        />
        <div>
          <div
            style={{ fontWeight: 'normal' }}
          >
            {props.goal}
          </div>

          <div style={{ color: '#687587', fontSize: 12 }}>
            {`${props.teamName}: ${props.ownerFullName}`}
            <span className="dotClass">.</span>
            {year}
          </div>
        </div>

      </div>
    )
  }

  const copySubmit = (e) => {
    e.persist();
    e.stopPropagation();
    e.preventDefault();
    reactLoader();
    // var searchFeild = document.querySelectorAll('.copyError')[0] ;
    const searchFeild = document.querySelectorAll('[data-testid="wbui-autocomplete-input"]')[0];
    if (okrData) {
      const params = {};
      params.krId = props.metric.id;
      params.okrId = okrData.id;
      params.comments = options.comments;
      params.move = options.move;
      if (props.krDetailsDataAction) {
        params.krDetails = true;
      }
      goalServices.copyKrToOkr(params)
        .then((response) => {
          viewGoalDetailsPage($(e.target), { id: params.okrId, oldId: window.location.href });
          removeReactLoader();
          if (props.krDetailsDataAction) {
            if (params.move) {
              props.krDetailsDataAction({
                ...response.data.data[0],
              })
            }
          } else if (params.move) {
            if (props.deleteKrAction) {
              props.deleteKrAction(params.krId, props.goalId, props.teamId, props.loggedInUser)
            }
            if (props.addNewKrAction) {
              props.addNewKrAction({ ...props.metric, goal_id: params.okrId, user_id: props.loggedInUser }, okrData.teamId)
            }
          } else if (props.addNewKrAction) {
            props.addNewKrAction({ ...response.data.data[0].metric, user_id: props.loggedInUser }, okrData.teamId)
          }
          handleModalClose()
        })
        .catch((error) => {
          removeReactLoader();
          console.log(error);
          setMessage(`${t('Something went wrong.')} ${t('Please try again.')}`)
          searchFeild.focus();
        })
    } else {
      removeReactLoader();
      setMessage(`${t('Please search and select an objective.')}`)
      searchFeild.focus();
    }
  }
  const selectOKr = (data, closeBox) => {
    setOkrData(data)
    if (closeBox) {
      closeBox();
    }
  }

  const removeSelectedOkr = (e) => {
    e.stopPropagation()
    setOkrData(null);
  }

  console.log('copy kr props', props)

  const isCascadeResult = !!props.metric.cascade_goal_id;

  return (
    <ThemeProvider>
      <StyledModal
        title={`${t('Copy key result to a different objective')}`}
        isOpen={props.isOpen}
        onDismiss={handleModalClose}
        onClose={handleModalClose}
        onSubmit={(e) => copySubmit(e)}
        data-testid="copy-kr-goal-search-modal" // Automation id example.
        submitLabel={t('Copy')}
        tabIndex="0"
      >
        <div style={{ height: '300px' }}>
          <div className="wherekrDataCome" style={{ marginBottom: '10px' }}>
            {`${t('Select an objective')}`}

          </div>
          <div style={{ display: 'block' }}>
            <Autocomplete
              autoHighlight={false}
              autoSelect={false}
              label=""
              icon={<Search />}
              placeholder={`${t('Search for objective')}`}
              options={goalListForSearch}
              getOptionLabel={(option) => option.goal || ''}
              startMatch={false}
              onChange={(e, v) => {
						  e.preventDefault();
						  selectOKr(v);
              }}
              template={renderSearchObjective}
              filterOptions={(x) => x}
              query={async (term) => {
						  setMessage('')
						  if (term) {
						    return goalSearch(term)
						  }
						  return []
              }}
              rootProps={{
						  'aria-labelledby': 'copy-kr-goal-search_dropdown', // ARIA attribute example.
						  'data-testid': 'copy-kr-goal-search-box', // Automation id example.
                // className: 'copy-kr-goal-search-box-root'
              }}
              panelProps={{
						  id: 'copy-kr-goal-search-dropdown',
						  style: { zIndex: 10000 }
              }}
              value=""
              className="autocomplete-searchbox"
            />
          </div>
          {okrData && (
          <div style={{ marginTop: 20 }}>
            {`${t('Selected objective')}`}
            <div style={{
              display: 'flex', justifyContent: 'space-between', alignItems: 'center', borderLeft: '4px solid #82CDE9', padding: 2, paddingLeft: 8, marginTop: 5
            }}
            >
              <div style={{ width: '90%' }} tabIndex="0">
                <div
										// className="goaltitle showtooltip-title"
                  style={{ fontWeight: 'normal' }}
                >
                  {okrData.goal}
                </div>

                <div style={{ color: '#687587', fontSize: 12 }}>
                  {`${okrData.teamName}: ${okrData.ownerFullName}`}
                  <span className="dotClass">.</span>
                  {okrData.okrPeriod}
                </div>
              </div>
              <div
                className="icon icon-outline-close-24px"
                style={{ cursor: 'pointer' }}
                onClick={(e) => removeSelectedOkr(e)}
									// onClick={() => this.toggleConfirmDialog(metric, index, "delete")}
                tabIndex="0"
                onKeyDown={(e) => KeyDownEvent(e, () => removeSelectedOkr(e))}
              />
            </div>
            <div style={{ display: 'flex', marginTop: 15, alignItems: 'center' }} className="copy-kr-selected-okr-otpions">
              <Checkbox
                name="comments"
                label={t('Include updates and comments')}
                isChecked={options.move ? true : options.comments}
                disabled={(props.metric.source == 3 && props.metric.type == 2) ? !options.move : options.move}
                onChange={() => setOptions({
									  ...options,
									  comments: !options.comments
                })}
              />
              <Checkbox
                name="updates"
                label={`${t('Only move result to new objective')}`}
                isChecked={options.move}
                onChange={() => setOptions({
									  comments: (props.metric.source == 3 && props.metric.type == 2) ? (options.move ? false : options.comments) : !options.move ? false : options.comments,
									  move: !options.move
                })}
                isDisabled={isCascadeResult}
              />
              {isCascadeResult && (
                <div className="icon icon-outline-help_outline-14px helptextcomp-icon"
                  title={t('Cascades cannot be moved')} />
              )}
            </div>
          </div>)}
          {
						message
						&& <div style={{ color: '#d93630', marginTop: 10 }} tabIndex="0" className="copyError">
  {message}
         </div>
					}
        </div>
      </StyledModal>
    </ThemeProvider>

  );
})

export default CopyKrModal;
